import { Badge } from '@mantine/core'
import React from 'react'
import { ThemeConfig } from '../../utils/themeConfig'

interface ReportElementProps {
  name: string
  themeConfig: ThemeConfig
}

export default function ReportElement({ name, themeConfig }: ReportElementProps) {
  return (
    <Badge
      size="lg"
      radius="md"
      variant="light"
      className="px-4 py-2 transition-all hover:scale-105"
      styles={{
        root: {
          backgroundColor: `${themeConfig.primaryColor}10`,
          color: themeConfig.primaryColor,
          fontSize: '0.9rem',
          cursor: 'default',
        },
      }}
    >
      {name}
    </Badge>
  )
}
